import { CatalogueConfig } from '@domgen/dgx-fe-catalogue';
import { AppConfig } from '../../models/config/app-config.type';

export const catalogueConfigFactory = (config: AppConfig): CatalogueConfig => ({
  basketApi: config.basketApi,
  catalogueApi: config.catalogueApi,
});
